import { isEmpty } from "lodash-es";

import type { $ZodErrorTree } from "zod/v4/core";

export interface ErrorProps {
  error: boolean;
  helperText?: string;
}

export function extractZodTreeErrorProps<T>(
  errors: { display: boolean; errors: $ZodErrorTree<T> | null },
  path: (string | number)[],
): ErrorProps {
  if (!errors.display || !errors.errors) return { error: false };

  const error = getZodErrorTreeErrorAtPath(errors.errors, path);
  return {
    error: !isEmpty(error),
    helperText: error,
  };
}

function getZodErrorTreeErrorAtPath<T>(
  errorObj: $ZodErrorTree<T>,
  path: (string | number)[],
): string | undefined {
  let acc: unknown = errorObj;

  for (const key of path) {
    // First, if acc has a "properties" field, dive into it automatically:
    if (
      acc !== null &&
      typeof acc === "object" &&
      // oxlint-disable-next-line typescript/no-unsafe-type-assertion
      "properties" in (acc as Record<string, unknown>)
    ) {
      // oxlint-disable-next-line typescript/no-unsafe-type-assertion
      acc = (acc as Record<string, unknown>).properties;
    }

    // Then try to access the key:
    if (acc !== null && (typeof acc === "object" || Array.isArray(acc))) {
      // oxlint-disable-next-line typescript/no-unsafe-type-assertion
      acc = (acc as Record<string | number, unknown>)[key];
    } else {
      // if we can't go deeper, stop and return undefined
      return undefined;
    }
  }

  return Array.isArray(acc)
    ? // oxlint-disable-next-line typescript/no-unsafe-type-assertion
      (acc as string[]).join(", ")
    : // oxlint-disable-next-line typescript/no-unsafe-type-assertion
      typeof acc === "object" && acc !== null && "errors" in (acc as Record<string, unknown>)
      ? ((acc as { errors?: string[] }).errors?.join(", ") ?? undefined)
      : undefined;
}
